import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/AdminLogin.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'StudentHome',
    component: () => import('@/views/student/Home.vue'),
    meta: { requiresAuth: true, roles: ['student', 'student_admin'] },
  },
  {
    path: '/activity/:id',
    name: 'ActivityDetail',
    component: () => import('@/views/student/ActivityDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/my-registrations',
    name: 'MyRegistrations',
    component: () => import('@/views/student/MyRegistrations.vue'),
    meta: { requiresAuth: true, roles: ['student', 'student_admin'] },
  },
  {
    path: '/my-score',
    name: 'MyScore',
    component: () => import('@/views/student/MyScore.vue'),
    meta: { requiresAuth: true, roles: ['student', 'student_admin'] },
  },
  {
    path: '/student-admin',
    name: 'StudentAdminHome',
    component: () => import('@/views/teacher/Home.vue'),
    meta: { requiresAuth: true, roles: ['student_admin'] },
  },
  {
    path: '/student-admin/activity/create',
    name: 'CreateActivity',
    component: () => import('@/views/teacher/CreateActivity.vue'),
    meta: { requiresAuth: true, roles: ['student_admin'] },
  },
  {
    path: '/student-admin/activity/:id/edit',
    name: 'EditActivity',
    component: () => import('@/views/teacher/EditActivity.vue'),
    meta: { requiresAuth: true, roles: ['student_admin'] },
  },
  {
    path: '/student-admin/activity/:id/registrations',
    name: 'ActivityRegistrations',
    component: () => import('@/views/teacher/ActivityRegistrations.vue'),
    meta: { requiresAuth: true, roles: ['student_admin', 'admin'] },
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('@/views/admin/Home.vue'),
    meta: { requiresAuth: true, roles: ['admin'] },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  if (to.meta.requiresAuth === false) {
    next()
    return
  }

  if (!userStore.isLoggedIn) {
    next({ name: 'Login' })
    return
  }

  const roles = to.meta.roles as string[] | undefined
  if (roles?.length && !roles.includes(userStore.userRole)) {
    if (userStore.isAdmin) next({ name: 'AdminHome' })
    else if (userStore.isStudentAdmin) next({ name: 'StudentAdminHome' })
    else next({ name: 'StudentHome' })
    return
  }

  next()
})

export default router
